import { StrictMode, Suspense, lazy } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from 'redux/store';
const App = lazy(() => import('./App'));

function AppProviders() {
    return (
        <Provider store={store}>
            <BrowserRouter>
                <Suspense fallback={<div>Cargando...</div>}>
                    <App />
                </Suspense>
            </BrowserRouter>
        </Provider>
    );
}

const container = document.getElementById('root');
if (container) {
    createRoot(container).render(
        <StrictMode>
            <AppProviders />
        </StrictMode>
    );
}
